import { render, staticRenderFns } from "./Objecten.vue?vue&type=template&id=6f0741e7&scoped=true&"
import script from "./Objecten.vue?vue&type=script&lang=js&"
export * from "./Objecten.vue?vue&type=script&lang=js&"
import style0 from "./Objecten.vue?vue&type=style&index=0&id=6f0741e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0741e7",
  null
  
)

export default component.exports